import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Users from "../customers/users";
import Admins from "../customers/admins";
import Companies from "./companies/all";
import ProtectedRoute from "../../../components/util-components/ProtectedRoute";

const PARENT_URL = "/cms/customers";

const Customers = () => {
  return (
    <Routes>
      <Route
        path={`/users`}
        element={
          <ProtectedRoute routeKey={"shop-users"}>
            <Users />
          </ProtectedRoute>
        }
      />
      <Route
        path={`/admins`}
        element={
          <ProtectedRoute routeKey={"shop-admin"}>
            <Admins />
          </ProtectedRoute>
        }
      />
      <Route
        path={`/companies`}
        element={
          <ProtectedRoute routeKey={"shop-users"}>
            <Companies />
          </ProtectedRoute>
        }
      />
      <Route path={``} element={<Navigate to={`${PARENT_URL}/customers`} replace />} />
    </Routes>
  );
};

export default Customers;
